import * as React from 'react';
import Box from '@mui/material/Box';
import CustomBackdrop from '../../../../../../Components/CustomBackdrop/Barckdrop';
import CustomDataGrid from '../../../../../../Components/CustomDataGrid/CustomDataGrid';
import { Button } from '@mui/material';
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded';
import ReportDatagrid from '../../../../../../PopUp/Components/PSReportDatagrid';
import FullScreenDialog from '../../../../../../Components/CustomDialogs/Fullscreendialog';
import filterNonUniqueBy from '../../../../../../CustomFunction/Arraymanage/filterNonUniqueBy';


const columns = [
    { field: 'id', headerName: 'id', width: 0, hide: true },
    {
        field: 'code',
        headerName: 'รหัสรายงาน',
        width: 200,
        editable: false,

    },
    {
        field: 'nameth',
        headerName: 'ชื่อรายงาน',
        width: 500,
        editable: false,
        flex: 1
    },
];
const styleMenu = {
    color: "black",
    cursor: "pointer",
    fontFamily: "Customfont !important",
    borderColor: "#bcbcbc",
    backgroundColor: "#bcbcbc",

}

export default function Reportlist(props) {
    const { defaultData } = props
    const [rows, setRows] = React.useState([])

    const [openbackdrop, setopenbackdrop] = React.useState(false)
    const [openModle, setOpenModle] = React.useState(false)
    const [title, setTitle] = React.useState("เลือกรายงาน")
    const [buttontxt, setButtontxt] = React.useState("")

    const [openFullScreenDialog, setopenFullScreenDialog] = React.useState(false)
    const [titleFullScreenDialog, settitleFullScreenDialog] = React.useState("เลือกรายงาน")


    React.useEffect(() => {
        setDefaultData()
        return () => {

        }
    }, [])

    const setDefaultData = () => {
        setRows(defaultData)
    }


    const selectReport = () => {
        //setOpenModle(true)
        setopenFullScreenDialog(true)
    }

    const customButtons = <>

        <Button variant="outlined" startIcon={<GroupAddRoundedIcon />} size="small" onClick={e => selectReport()}
            sx={styleMenu}
        >
            เลือกรายงาน
        </Button>
    </>


    const resData = (e) => {
        props.resData(e)
    }
    const removeresData = async (e) => {
        console.log("  removeresData e", e)

        let arr = [...e, ...rows]

        let arrs = await filterNonUniqueBy(arr, (a, b) => a.code == b.code)

        await console.log("arrs", arrs);
        await setRows(arrs)

        // let array1
        // try {
        //     if (e.length > 0) {
        //         //setLoadData(true)
        //         if (rows.length > 0) {
        //             // console.log("optionData optionData if case")

        //             array1 = e.filter(val => {
        //                 return !rows.find((val2) => {
        //                     //  console.log({valueID:val.id+":"+val2.id});
        //                     return val.code === val2.code
        //                 })
        //             });

        //         } else {
        //             console.log("optionData optionData else case")
        //             array1 = val.filter(val => {
        //                 return val
        //             })
        //         }
        //     } else {
        //         console.log("optionData val.length else case")
        //         //val.length else case
        //         array1 = []
        //     }

        // } catch (error) {
        //     console.log("optionData error", error)
        //     array1 = []
        // }

        // await setRows(array1)
    }
    const selcetRow = (e) => {
        props.Dataselect(e)
        // console.log("selcetRow", e)
    }
    const resinput = (e) => {
        setInputtext(e)
    }
    const keyDown = (e) => {
        console.log(e);
        if (e === "Enter") {
            loadData("search")
        }
    }
    let idCounter = 0
    const rsDataselect = (e) => {
        setopenFullScreenDialog(false)
        setopenbackdrop(true)
        setTimeout(() => {

            if (rows.length > 0) {
                const ids = rows.map(object => {
                    return object.id;
                });
                const max = Math.max(...ids);
                idCounter = max
            }


            let array1 = e.filter(val => {
                return !rows.find((val2) => {
                    //  console.log({valueID:val.id+":"+val2.id});
                    return val.code === val2.code
                })
            });

            if (array1.length > 0) {
                for (let index = 0; index < array1.length; index++) {
                    idCounter += 1;
                    if ((index + 1) === array1.length) {
                        setopenbackdrop(false)
                    }
                    setRows((prevRows) => [...prevRows, { id: idCounter, code: e[index].code, nameth: e[index].nameth }])
                }
            } else {
                setopenbackdrop(false)
            }
        }, 300);
    }
    const closeDialog = () => {
        // setOpenModle(false)
        setopenFullScreenDialog(false)
    }
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            < CustomDataGrid
                datacolumns={columns}
                datarows={rows}
                rowHeight={38}
                Dataintable={e => resData(e)}
                Dataintableremove={e => removeresData(e)}
                startRow={0}
                option={[{ add: false, del: true, select: false }]}
                checkboxSelection
                Dataselect={e => selcetRow(e)}
                RowsModelChange={_ => console.log("RowsModelChange")}
                customButton={customButtons}
            />
            <CustomBackdrop open={openbackdrop} />
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} CloseDialog={_ => closeDialog()}>
                <ReportDatagrid Dataselect={e => rsDataselect(e)} />
            </FullScreenDialog>
        </Box >
    );
}